<div class="flex md:flex-col justify-center mt-10"
    *ngIf="lilate && (lilate.status !== 'done' && lilate.examination_session_status != 'pending_assessment')">
    <div class="flex flex-col md:flex-row rounded-2xl shadow-xl">
        <!-- BLOC GAUCHE -->
        <div
            class="flex flex-col items-center p-8 md:px-10 md:py-12 min-w-60 bg-gray-100 dark:bg-black dark:bg-opacity-10 rounded-gauche">
            <!-- CAS PLANIFIÉ ET PB IDENITÉ -->
            <ng-container
                *ngIf="(lilate.status == 'booked' || lilate.status == 'identity_issue') && lilate.examination_session_status != 'pending_assessment'">
                <app-lilate-card-booked-rec *ngIf="lilate.status == 'booked'" [bloc]="'gauche'"
                    [lilate]="lilate"></app-lilate-card-booked-rec>
                <app-lilate-card-identity-issue-rec *ngIf="lilate.status == 'identity_issue'" [bloc]="'gauche'"
                    [lilate]="lilate"></app-lilate-card-identity-issue-rec>
            </ng-container>

            <!-- <ng-container *ngIf="lilate.examination_session_status === 'pending_assessment'">
                <app-lilate-card-pending_assessment [bloc]="'gauche'"
                    [lilate]="lilate"></app-lilate-card-pending_assessment>
            </ng-container> -->

            <!-- CAS À PLANIFIER OU ANNULER PAR PROF -->
            <ng-container *ngIf="(lilate.status === 'pending_booking' || lilate.status == 'cancelled_by_teacher')">
                <app-lilate-card-pending-booking-rec *ngIf="lilate.status == 'pending_booking'" [bloc]="'gauche'"
                    [lilate]="lilate"></app-lilate-card-pending-booking-rec>
                <app-lilate-card-cancelled-by-teacher-rec *ngIf="lilate.status == 'cancelled_by_teacher'" [bloc]="'gauche'"
                    [lilate]="lilate"></app-lilate-card-cancelled-by-teacher-rec>
            </ng-container>
        </div>

        <!--- BLOC DROIT --->
        <div class="p-6 sm:p-8 md:p-10 bg-white rounded-droite">
            <div class="flex items-center font-bold">
                <div class="flex w-10 min-w-10"><img class="w-full h-10" src="{{lilate.language.flag}}" alt="language-flag"></div>
                <div class="text-2xl w-10/12 ml-5">
                    <div translate [translateParams]="{language:lilate.language.label}">lilate-exam.certif.name.1</div>

                    <!-- <div class="text-gray-700 text-base font-normal" *ngIf="lilate.in_training" translate
                        [translateParams]="{start: lilate.validity_period_from | date:'dd/MM/yyyy', end: lilate.validity_period_to | date:'dd/MM/yyyy'}">
                        lilate-exam.date-slot-time
                    </div> -->
                </div>
            </div>

            <!--<div>
                <div class="mt-4 leading-relaxed text-gray-700">{{ lilate.company.name }}</div>
                <div *ngIf="lilate.in_training">Formation du {{ lilate.validity_period_from | date:'dd/MM/yyyy' }} au {{ lilate.validity_period_to | date:'dd/MM/yyyy' }}</div>
            </div>-->

            <ng-container *ngIf="lilate.status === 'pending_booking' || lilate.status == 'cancelled_by_teacher'">
                <app-lilate-card-pending-booking-rec *ngIf="lilate.status == 'pending_booking'" [bloc]="'droite'"
                    [lilate]="lilate"></app-lilate-card-pending-booking-rec>
                <app-lilate-card-cancelled-by-teacher-rec *ngIf="lilate.status == 'cancelled_by_teacher'" [bloc]="'droite'"
                    [lilate]="lilate"></app-lilate-card-cancelled-by-teacher-rec>
            </ng-container>

            <ng-container
                *ngIf="(lilate.status == 'booked' || lilate.status == 'identity_issue') && lilate.examination_session_status != 'pending_assessment' ">
                <app-lilate-card-booked-rec *ngIf="lilate.status == 'booked'" [bloc]="'droite'"
                    [lilate]="lilate"></app-lilate-card-booked-rec>
                <app-lilate-card-identity-issue-rec *ngIf="lilate.status == 'identity_issue'" [bloc]="'droite'"
                    [lilate]="lilate"></app-lilate-card-identity-issue-rec>
            </ng-container>

            <!-- ASSESSMENT EN COURS -->
            <!-- <ng-container *ngIf="lilate.examination_session_status == 'pending_assessment'">
                <app-lilate-card-pending_assessment [bloc]="'droite'"
                    [lilate]="lilate"></app-lilate-card-pending_assessment>
            </ng-container> -->
        </div>
    </div>
</div>



<!-- CAS ASSESSMENT EN COURS -->
<div *ngIf="lilate && lilate.status === 'done'" class="flex flex-col max-w-80 w-full p-6 h-full">
    <app-lilate-card-done-rec *ngIf="lilate.status === 'done'" [lilate]="lilate"></app-lilate-card-done-rec>
</div>

<!-- CAS ASSESSMENT EN COURS -->
<div *ngIf="lilate && lilate.examination_session_status === 'pending_assessment'"
    class="flex flex-col max-w-80 w-full p-6 h-full">
    <app-lilate-card-pending-assessment-rec *ngIf="lilate && lilate.examination_session_status === 'pending_assessment'"
        [lilate]="lilate"></app-lilate-card-pending-assessment-rec>
</div>